import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state: {
        login_name: localStorage.getItem('username') || null,
        questions : {},

        question : 1,
        bearrer:localStorage.getItem('user-token') || null,
        isTeacher : localStorage.getItem('isTeacher') || false,


    },
    getters: {
        getLoginName: state => {
            return state.login_name
        },
        getquestion: state => {
            return state.question
        },
        getquestions: state => {
            return state.questions
        },
        getIsTeacher : state => {
            return state.isTeacher
        }
    },
    mutations: {
        setLoginName(state,{name}) {
            state.login_name = name;
        },
        setBearrer(state,{bearrer}) {
            state.bearrer = bearrer;
        }
        ,
        setIsTeacher(state,{isTeacher}) {
            state.isTeacher = isTeacher;
        }

    },
    actions: {
        setLoginName ( { commit,state }, {name})
        {
            commit('setLoginName', {name});
        },
        setIsTeacher ( { commit,state }, {isTeacher})
        {
            commit('setIsTeacher', {isTeacher});
        },
        setBearrer ( { commit,state }, {bearrer})
        {
            commit('setBearrer', {bearrer});
        }
    }
})
